import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessCategorySchema } from '../../entities/process/process.schema';
import { ProcessSwimlaneMappingSchema } from '../../entities/process-chain/process-chain.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
/**
 * A node in the process chain tree
 * Recursive structure: each node can have children
 */ export const ProcessChainTreeNodeSchema = z.lazy(()=>z.object({
        _id: z.string(),
        name: z.string(),
        category: ProcessCategorySchema,
        parentChainId: z.string().nullable().optional(),
        description: z.string().optional(),
        e2eLabel: z.string().optional(),
        processCount: z.number().int(),
        childCount: z.number().int(),
        processSwimlaneMappings: z.array(ProcessSwimlaneMappingSchema),
        children: z.array(ProcessChainTreeNodeSchema)
    }));
/**
 * Get Process Chain Tree Response Schema
 * GET /api/v2/process-chains/tree
 * Returns the full hierarchy grouped by category
 */ export const GetProcessChainTreeResponseSchema = z.object({
    management: z.array(ProcessChainTreeNodeSchema),
    core: z.array(ProcessChainTreeNodeSchema),
    support: z.array(ProcessChainTreeNodeSchema)
});
export const GetProcessChainTreeErrorSchema = BaseErrorSchema;

//# sourceMappingURL=get-process-chain-tree.schema.js.map